import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_TEM002_Request,
  IAPI_TEM002_Response,
  IAPI_TEM003_Request,
  IAPI_TEM003_Response,
  IAPI_TEM004_Request,
  IAPI_TEM004_Response,
} from "../../../type/apiType";

/**
 * メールテンプレート参照API
 * @return httpMailTemplatesRefer
 */
const httpAPI_TEM002 = async (
  param: IAPI_TEM002_Request
): Promise<IAPI_TEM002_Response> => {
  let res = await http.post(ApiUrl.API_TEM002, {
    ...param,
  });

  return res.data;
};

/**
 * メールテンプレート更新API
 * @return httpMailTemplatesUpdate
 */
const httpAPI_TEM003 = async (
  param: IAPI_TEM003_Request
): Promise<IAPI_TEM003_Response> => {
  let res = await http.post(ApiUrl.API_TEM003, {
    ...param,
  });

  return res.data;
};

/**
 * メールテンプレート削除API
 * @return httpMailTemplatesDelete
 */
const httpAPI_TEM004 = async (
  param: IAPI_TEM004_Request
): Promise<IAPI_TEM004_Response> => {
  let res = await http.post(ApiUrl.API_TEM004, {
    ...param,
  });

  return res.data;
};

export { httpAPI_TEM002, httpAPI_TEM003, httpAPI_TEM004 };
